import { Box, Divider, Heading, Image, Text } from "@chakra-ui/react";
export const BloggCard = ({ item }) => {
  const calculteDate = () => {
    let createdAt = item.createdAt;
    let newStr = "";
    for (var i = 0; i < 10; i++) {
      newStr += createdAt[i];
    }
    return newStr;
  };

  return (
    <Box
      width="100%"
      border="1px solid transparent"
      height={{base:"460px",sm:"420px",xl:"340px",lg:"350px"}}
      display={{ md: "block", sm: "block", md: "flex",xl:"flex", lg: "flex" }}
      marginBottom="2%"
      boxShadow={`rgba(0, 0, 0, 0.24) 0px 3px 8px`}
    >
      {/* image div */}
      <Box width={{base:"100%",sm:"100%",md:"50%",lg:"50%"}} border="1px solid transparent" height={{base:"50%",sm:"50%",md:"100%",lg:"100%"}}
       marginRight={"3%"}>
        <Image
          width={{ base: "100%", lg: "100%" }}
          height="100%"
          src={item.image}
        ></Image>
        {/* </Box> */}
      </Box>
      <Box width={{base:"100%",sm:"100%",md:"50%",lg:"50%"}} border="1px solid transparent" height="100%">
        <Text fontFamily={"sans-serif"} fontSize={"12px"} marginTop={"5%"}>
          EDITOR'S PICK
        </Text>
        <Heading
          fontSize={{ base: "15px",sm:"16px", md: "22px", lg: "24px" }}
          fontFamily={"mono"}
          marginTop={"2%"}
        >
          {item.title}
        </Heading>
        <Text className="elipsis" border="1px solid transparent"
          fontFamily={"cursive"}
          marginTop={"1%"}
          marginBottom={{base:"0%",sm:"0%",md:"0%",xl:"1%",lg:"2%"}}
          fontSize={{base:"12px",md:"13px",xl:"15px",lg:"17px"}}
        >
          {item.meta_data}
        </Text>
        <Text fontSize={"13px"} marginTop={{base:"2%",sm:"3%",md:"12px",xl:"14px",lg:"7%"}} fontWeight="600">
          By {item.writter}
        </Text>
        <Text fontSize={"13px"} marginTop={"1%"} fontWeight="600">
          CreatedAt: {calculteDate()}
        </Text>
        <Box
          marginTop={{base:"1%",sm:"2%",md:"3%",xl:"5%",lg:"5%"}}
          width={"57%"}
          marginBottom="2%"
          border="1px solid black"
          backgroundColor={"gray"}
        ></Box>
      </Box>
    </Box>
  );
};
